// @flow
import React from 'react';
import { IMAGE_PATH, isProd } from '../util/config';
const logoPath = `${IMAGE_PATH}/logo/team-engine-logo-with-name-white.png`;

const styles = {
  appBar: {
    backgroundColor: isProd ? '#455a64' : '#bf360c',
    minHeight: 0,
    padding: '5px 10px',
    textAlign: 'left',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.14)',
  },
  link: {
    textDecoration: 'none',
  },
};

export const Nav = () => (
  <div style={styles.appBar}>
    <img src={logoPath} height="30" alt="Home" />
  </div>
);
